import { render, staticRenderFns } from "./adminLoginPage.vue?vue&type=template&id=ca06ccce&scoped=true"
import script from "./adminLoginPage.vue?vue&type=script&lang=js"
export * from "./adminLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca06ccce",
  null
  
)

export default component.exports